import Header from '../../Components/Header/Header';
import React, { useEffect, useState } from 'react';
import './Assignmentdetailsupdate.css';
import { postCall, putCall } from '../../Services/CommonService';
import { useNavigate, useParams } from 'react-router-dom';
import AssignmentDetailsHeader from '../common/AssignmentDetailsHeader';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import * as Constants from '../../constants/RepoReactConstants';
import { PINNCALE_LOG_OBJ } from '../../constants/commonJsonConstants';

import { CommonDataService, getcommentStr } from '../../Services/CommonDataService';

import { AssignmentService } from '../../Services/AssignmentService';


import { showAlert } from '../../Services/CommonFunctions';
import { rs_COMMENT_TXT } from '../../constants/RepoReactConstants';

// Moved to outer/module scope since it doesn't depend on component state/props
function getCurrentTimestamp() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // JavaScript months are 0-indexed
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function AssignmentDetailsUpdate() {
  const [accountInformation, setAccountInformation] = useState([]);
  const [contractorInfoForComment, setContractorInfoForComment] = useState([]);
  const [actionTakenList, setActionTakenlist] = useState([]);

  const [assignmentUpdateDetail, setAssignmentUpdateDetail] = useState({});


  const navigate = useNavigate();
  let { teamWrkBpiNb } = useParams();
  console.log(teamWrkBpiNb);


  const userInfo = getUserInfoFromSession();

  const onChangeHandlerStr = (event) => {
    setAssignmentUpdateDetail(() => ({
      ...assignmentUpdateDetail,
      [event.target.name]: String(event.target.value),
    }));
  };


  useEffect(() => {

    const fetchcommonInfo = async () => {
      try {
        const [
          accountInfoResponse,
          contractorInfoForCommentResponse,
          ,
          actionTakenListResponse
        ] = await Promise.all([
          CommonDataService.getAccountInfo(teamWrkBpiNb, userInfo.cntrctrNb),
          CommonDataService.getCntrctrInfoForComments(userInfo.userid),
          AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb),
          CommonDataService.getActionList()
        ]);

        setAccountInformation(accountInfoResponse.data);
        setContractorInfoForComment(contractorInfoForCommentResponse.data);
        setActionTakenlist(actionTakenListResponse.data);

        console.log(
          `getBuyerCobuyer Params coBusCd: ${accountInfoResponse?.data?.coBusCd} ` +
          `disorigBranchCd: ${accountInfoResponse?.data?.discorigBranchCd} ` +
          `custAcctNb: ${accountInfoResponse?.data?.custAcctNb}`
        );
        console.log(actionTakenListResponse.data);
      } catch (error) {
        // Handle any errors that occur in any of the promises
        console.error('An error occurred:', error);
      }
    };
    fetchcommonInfo();
  }, [teamWrkBpiNb, userInfo.cntrctrNb, userInfo.userid]);


  const logPinnacle = async (accountInformation, contractorInfoForComment, PINNCALE_LOG_OBJ, actNotes, actCode) => {
    PINNCALE_LOG_OBJ.receivableAccountNumber = accountInformation.custAcctNb;
    PINNCALE_LOG_OBJ.coBusCd = accountInformation.coBusCd;
    PINNCALE_LOG_OBJ.createdTimeStamp = getCurrentTimestamp();
    PINNCALE_LOG_OBJ.enteredBranchCode = accountInformation.superBranchCd;
    PINNCALE_LOG_OBJ.createdBy = 'FCREPO';
    PINNCALE_LOG_OBJ.comment = getcommentStr(contractorInfoForComment, actNotes, actCode, userInfo.userid);
    console.log(' after comment set:::::::::::::::::::', PINNCALE_LOG_OBJ);
    return CommonDataService.createPinnacleContact(PINNCALE_LOG_OBJ);
  };




  const countCharacters = (event) => {
    const currentLength = event.target.value.length;
    console.log("Current character count (on keyUp/focus/paste):", currentLength);
  };

  async function Submit() {
    try {

      console.log("Submit button clicked!");
      // *** HERE'S WHERE YOU LOG THE CURRENT STATE VALUE ON SUBMIT ***
      console.log("comment on update assignment page::::::::::", assignmentUpdateDetail);

      let assignmentupdatecomment = getcommentStr(contractorInfoForComment, assignmentUpdateDetail.actiontaken+assignmentUpdateDetail.commentTxt, Constants.rs_CONTRACTOR_UDATE, userInfo.userid);

      console.log(" comments  to log in WF2:::",assignmentupdatecomment)

      const [pinnResp, putResp, postResp] = await Promise.all([
        logPinnacle(
          accountInformation,
          contractorInfoForComment,
          PINNCALE_LOG_OBJ,
          assignmentUpdateDetail.actiontaken + Constants.rs_COMMENT_TXT+assignmentUpdateDetail.commentTxt,
          Constants.rs_CONTRACTOR_UDATE
        ),

        //updateAssignmentdetails == put call
        putCall(
          'SqlMgr/updateAssignmentDetails?userId='+userInfo.userid +
          '&days='+2 +'&bpiNb=' +
          teamWrkBpiNb +
          '&cntrctrNb=' + userInfo.cntrctrNb
          +'&commentTxt='+assignmentUpdateDetail.commentTxt
        ),
        postCall('SqlMgr/WFCmt',{
          teamWrkBpiNb:parseInt(teamWrkBpiNb) ,
          wfCmtCd: 'G',
          wfCmtTx:assignmentupdatecomment,
          wfUserIdCd: 'FCREPO',
          lstUpdtUserId: 'FCREPO',
        })
      ]);

      showAlert('Assignment details Updated successfully!!', 'success').then(() => {
        navigate('/outstandingAssignment');
      });
      console.log('Pinnacle Response:', JSON.stringify(pinnResp));
      console.log('putCall Response:', JSON.stringify(putResp));
      console.log('postCall Response:', JSON.stringify(postResp));

    } catch (error) {
      console.error('Error in Promise.all:', error);
      showAlert('Error occurred  in updating assignment', 'error');
    }
  }

  function Cancel() {
    navigate('/outstandingAssignment');
  }
  return (
    <>
      <div>
        <div className="details_cntr_summmary">
          <Header heading="Assignment Update Details" />
          <br />
          <AssignmentDetailsHeader bpiNo={teamWrkBpiNb} />
          <br />
          <div>
            <div id="action_ctr">
              <div> Action Taken</div>
              <div>
                <select
                  name="actiontaken"
                  id="action-select"
                  className="fmc-select"
                  onChange={onChangeHandlerStr}
                  value={assignmentUpdateDetail.actiontaken}
                >
                  <option value=""></option>
                  {actionTakenList.map((options) => (
                    <option key={options.key} value={options.value}>
                      {options.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>




            <div className="para">
              <ul className="fmc-list">
                <li>
                  {' '}
                  Provide additional details specific to the assignment in the box below. Please refrain from including
                  personal information, and otherwise follow guidelines outlined in Section 5 of your Independent
                  Contractor Agreement.
                </li>
              </ul>
            </div>

            <div id="comment-row-container">
              <div>Comment :</div>
              <div className="fds-layout-grid__cell--span-6 comment-input-area">
                <fmc-textarea
                  maxLength="500"
                  name="commentTxt"

                  onInput={onChangeHandlerStr} // Add the onChange handler
                  value={assignmentUpdateDetail.commentTxt} // The value is now controlled by the single state variable
                  onKeyUp={countCharacters}
                  onFocus={countCharacters}
                  onPaste={countCharacters}
                ></fmc-textarea>
                <div className="remaining-characters-info">Remaining characters: of 500</div>
              </div>
            </div>
            <section id="button-section">
              <div className="button-group-container">
                <fmc-button label="Submit" onClick={Submit}></fmc-button>
                <fmc-button label="Cancel" onClick={Cancel}></fmc-button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignmentDetailsUpdate;
